import type { Module } from '@pc/core';
import { lazyWithReload } from '@pc/ui';

const CampaignsListPage = lazyWithReload(() => import('./pages/CampaignsListPage'));
const CampaignDetailPage = lazyWithReload(() => import('./pages/CampaignDetailPage'));
const CampaignNewPage = lazyWithReload(() => import('./pages/CampaignNewPage'));
const SmsTemplatesPage = lazyWithReload(() => import('./pages/SmsTemplatesPage'));
const MarketingDashboardWidget = lazyWithReload(
  () => import('./widgets/MarketingDashboardWidget'),
);

export const marketingModule: Module = {
  id: 'marketing',
  name: 'Marketing',
  description:
    'Bulk SMS campaigns to your clients. Reusable templates, per-recipient delivery tracking, opt-out aware.',
  basePath: '/marketing',
  routes: [
    { path: '/', element: <CampaignsListPage /> },
    { path: '/new', element: <CampaignNewPage /> },
    { path: '/templates', element: <SmsTemplatesPage /> },
    { path: '/:id', element: <CampaignDetailPage /> },
  ],
  // Single top-level nav entry. The Templates surface is reachable
  // via the in-page tab strip rendered by `MarketingTabs` on each
  // marketing list-level page -- it's a sub-page of this module, not
  // a sibling concept, and shouldn't compete for sidebar real estate.
  navItems: [
    { label: 'Marketing', to: '/marketing', order: 45 },
  ],
  dashboardWidgets: [
    {
      id: 'marketing-summary',
      span: 1,
      order: 40,
      render: MarketingDashboardWidget,
    },
  ],
};
